export default __webpack_public_path__ + "static/media/mailOutlined.82d62ff8.svg";